import { useEffect, useState } from "react";
import styled from "styled-components";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "../../../index.css";

const ContentContainer = styled.div`
  flex: 1;
  position: relative;
  background: rgba(255, 255, 255, 0.95);
  //   border-radius: 15px;
  backdrop-filter: blur(15px);
  border: 3px solid #40e0d0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: visible;
  max-height: calc(100vh - 4rem);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContentArea = ({ activeSection }) => {
  const [galleryData, setGalleryData] = useState([]);

  console.log(activeSection, "jkl");

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await fetch(`/galleryData/${activeSection}.json`);
        const data = await response.json();
        setGalleryData(data.images);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };

    if (activeSection) {
      fetchGalleryData();
    }
  }, [activeSection]);

  // ✅ Custom Left Arrow
  const renderLeftNav = (onClick, disabled) => (
    // <LeftNav onClick={onClick} disabled={disabled} />
    <button
      className="custom-left-nav"
      disabled={disabled}
      onClick={onClick}
      style={{
        border: "none",
        padding: "10px",
        cursor: "pointer",
        position: "absolute",
        top: "50%",
        left: "-10px",
        transform: "translateY(-50%)",
        zIndex: 1,
        borderRadius: "10px",
        backgroundColor: "black",
      }}
    >
      <ChevronLeft size={20} color="white" />
    </button>
  );

  // ✅ Custom Right Arrow
  const renderRightNav = (onClick, disabled) => (
    <button
      className="custom-right-nav"
      disabled={disabled}
      onClick={onClick}
      style={{
        border: "none",
        borderRadius: "10px",
        padding: "10px",
        cursor: "pointer",
        position: "absolute",
        top: "50%",
        right: "-10px",
        transform: "translateY(-50%)",
        zIndex: 1,
        backgroundColor: "black",
      }}
    >
      <ChevronRight size={20} color="white" />
    </button>
  );

  return (
    <>
      {galleryData.length > 0 && (
        <ImageGallery
          items={galleryData}
          showThumbnails={false}
          showFullscreenButton={true}
          showPlayButton={false}
          renderLeftNav={renderLeftNav}
          renderRightNav={renderRightNav}
          additionalClass="my-gallery"
          disableThumbnailScroll={false}
          disableThumbnailSwipe={false}
          disableSwipe={true}
          showBullets={false}
          useBrowserFullscreen={false}
        />
      )}
    </>
  );
};

export default ContentArea;
